import LegalPagePortal from "./LegalPagePortal";

export default LegalPagePortal;
